<div class="flex flex-col items-center">
    <img [src]="imgSrc" class="h-40 w-40 mb-6"/>
    <span class="h3-text text-text-primary text-center mb-2">{{ title }}</span>
    <span class="body-s-text text-text-muted text-center w-40 md:w-52">{{text}}</span>
</div>